// extracted by mini-css-extract-plugin
export default {"tooltip":"fS-z","arrow":"gS-z"};